import React from "react";
import cn from "classnames";

type TextInputProps = React.ComponentProps<"input"> & {
  error?: boolean;
};

const TextInput = ({ className, error, ...props }: TextInputProps) => {
  return (
    <input
      className={cn(
        "border border-solid border-gray-300 focus:border-primary",
        "px-3 py-2 rounded shadow-none w-full",
        "outline-none focus:outline-none focus:ring ring-primary ring-opacity-40",
        "hover:border-primary hover:ring transition-all",
        error ? "border-red-500" : "",
        className
      )}
      {...props}
    />
  );
};

export default TextInput;
